import { getText } from '../../../internal/TextLabels'

const GeneralErrors = {
  TEMPORARY: 'temporaryError',
  INTERNAL: 'internalError',
}

const translateError = errorType => getText(`apiErrors.${errorType}`)

export const getErrorCodeAndMessage = errorType => {
  switch (errorType) {
    case 404:
      return {
        code: 404,
        message: translateError(GeneralErrors.TEMPORARY),
      }
    case 500:
      return {
        code: 500,
        message: translateError(GeneralErrors.TEMPORARY),
      }
    case 0: {
      return {
        code: 0,
        message: translateError(GeneralErrors.INTERNAL),
      }
    }
    case 'ACCOUNT_NOT_FOUND':
      return {
        code: 1,
        message: translateError(errorType),
      }
    case 'ACCOUNT_NUMBER_MISSING':
      return {
        code: 2,
        message: translateError(errorType),
      }
    case 'ACCOUNT_NUMBER_NOT_FOUND':
      return {
        code: 3,
        message: translateError(GeneralErrors.INTERNAL),
      }
    case 'ADDRESS_NOT_FOUND':
      return {
        code: 4,
        message: translateError(errorType),
      }
    case 'AMOUNT_MISSING':
      return {
        code: 5,
        message: translateError(errorType),
      }
    case 'AMOUNT_OUT_OF_LOWER_BOUND':
      return {
        code: 6,
        message: translateError(errorType),
      }
    case 'AMOUNT_OUT_OF_UPPER_BOUND':
      return {
        code: 7,
        message: translateError(errorType),
      }
    case 'APPLICATION_FIELD_NOT_MATCHING_SYNTAX':
      return {
        code: 8,
        message: translateError(errorType),
      }
    case 'APPLICATION_MISSING':
      return {
        code: 9,
        message: translateError(errorType),
      }
    case 'APPLICATION_NOT_FOUND':
      return {
        code: 10,
        message: translateError(errorType),
      }
    case 'APPLICATION_TYPE_MISSING':
      return {
        code: 11,
        message: translateError(errorType),
      }
    case 'APPLICATION_TYPE_NOT_ALLOWED':
      return {
        code: 12,
        message: translateError(errorType),
      }
    case 'BAD_REQUEST':
      return {
        code: 13,
        message: translateError(GeneralErrors.INTERNAL),
      }
    case 'CARD_NOT_FOUND':
      return {
        code: 14,
        message: translateError(GeneralErrors.INTERNAL),
      }
    case 'CHAIN_ID_MISSING':
      return {
        code: 15,
        message: translateError(errorType),
      }
    case 'CREDIT_PRODUCT_NOT_CONFIGURED_FOR_PAYMENT_METHOD':
      return {
        code: 16,
        message: translateError(errorType),
      }
    case 'CUSTOMER_NOT_ALLOWED':
      return {
        code: 17,
        message: translateError(errorType),
      }
    case 'E_SIGNING_NOT_SUPPORTED':
      return {
        code: 18,
        message: translateError(errorType),
      }
    case 'EMPTY_PAYMENT':
      return {
        code: 19,
        message: translateError(errorType),
      }
    case 'FAILED_TO_PARSE_LIMIT_FORM':
      return {
        code: 20,
        message: translateError(errorType),
      }
    case 'FAILED_TO_PERFORM_LIMIT_RAISE':
      return {
        code: 21,
        message: translateError(errorType),
      }
    case 'FAILED_TO_SUBMIT_LIMIT_APPLICATION':
      return {
        code: 22,
        message: translateError(errorType),
      }
    case 'INVALID_CUSTOMER_TYPE':
      return {
        code: 23,
        message: translateError(errorType),
      }
    case 'INVALID_EXTERNAL_ID':
      return {
        code: 24,
        message: translateError(errorType),
      }
    case 'INVALID_GOVERNMENT_ID':
      return {
        code: 25,
        message: translateError(errorType),
      }
    case 'LIMIT_NOT_APPROVED':
      return {
        code: 26,
        message: translateError(errorType),
      }
    case 'LIMIT_NOT_FOUND':
      return {
        code: 27,
        message: translateError(errorType),
      }
    case 'LIMIT_RAISE_NOT_ALLOWED':
      return {
        code: 28,
        message: translateError(errorType),
      }
    case 'MALFORMED_REDIRECTION_URL':
      return {
        code: 29,
        message: translateError(errorType),
      }
    case 'MISSING_PEP_ID':
      return {
        code: 30,
        message: translateError(errorType),
      }
    case 'NO_VALID_ACCOUNT_EXISTS':
      return {
        code: 31,
        message: translateError(errorType),
      }
    case 'NO_VALID_CARD_EXISTS':
      return {
        code: 32,
        message: translateError(errorType),
      }
    case 'NOT_ENOUGH_LIMIT_ON_APPLICATION':
      return {
        code: 33,
        message: translateError(errorType),
      }
    case 'PAYMENT_METHOD_NOT_ALLOWED_FOR_CHANNEL':
      return {
        code: 34,
        message: translateError(errorType),
      }
    case 'PAYMENT_METHOD_NOT_FOUND':
      return {
        code: 35,
        message: translateError(errorType),
      }
    case 'PAYMENT_METHOD_TYPE_NOT_SUPPORTED':
      return {
        code: 36,
        message: translateError(errorType),
      }
    case 'PAYMENT_NOT_FOUND':
      return {
        code: 37,
        message: translateError(errorType),
      }
    case 'PAYMENT_WITH_EXTERNAL_ID_EXISTS':
      return {
        code: 38,
        message: translateError(errorType),
      }
    case 'REPRESENTATIVE_NOT_FOUND':
      return {
        code: 39,
        message: translateError(errorType),
      }
    case 'SIGNING_NOT_COMPLETED':
      return {
        code: 40,
        message: translateError(errorType),
      }
    case 'SIGNING_REQUIRED':
      return {
        code: 41,
        message: translateError(errorType),
      }
    case 'SIGNING_TYPE_NOT_SUPPORTED':
      return {
        code: 42,
        message: translateError(errorType),
      }
    case 'SIGNING_URL_EXCEPTION':
      return {
        code: 43,
        message: translateError(errorType),
      }
    case 'STORE_NOT_FOUND':
      return {
        code: 44,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_AUTHORIZE_PAYMENT':
      return {
        code: 45,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_CREATE_ACCOUNT':
      return {
        code: 46,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_CREATE_AGREEMENT':
      return {
        code: 47,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_CREATE_SIGNING_SESSION':
      return {
        code: 48,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_GET_FORM_SPECIFICATION':
      return {
        code: 49,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_GET_SIGNATURE_LOCALE':
      return {
        code: 50,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_GET_SIGNATURE_STATUS':
      return {
        code: 51,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_REGISTER_ACCOUNT':
      return {
        code: 52,
        message: translateError(GeneralErrors.INTERNAL),
      }
    case 'UNKNOWN':
      return {
        code: 53,
        message: translateError(GeneralErrors.INTERNAL),
      }
    case 'UNSUPPORTED_ACTION':
      return {
        code: 54,
        message: translateError(errorType),
      }
    case 'INVOICE_ID_NOT_ALLOWED':
      return {
        code: 55,
        message: translateError(errorType),
      }
    case 'INVOICE_ID_ALREADY_EXISTS':
      return {
        code: 56,
        message: translateError(errorType),
      }
    case 'PAYMENT_ALREADY_ANNULLED':
      return {
        code: 57,
        message: translateError(errorType),
      }
    case 'PAYMENT_COMPLETED':
      return {
        code: 58,
        message: translateError(errorType),
      }
    case 'COULD_NOT_CONVERT_PAYMENT':
      return {
        code: 59,
        message: translateError(errorType),
      }
    case 'BILLING_ADDRESS_MISSING':
      return {
        code: 60,
        message: translateError(errorType),
      }
    case 'PAYMENT_FILTER_STATUS_NOT_VALID':
      return {
        code: 61,
        message: translateError(errorType),
      }
    case 'UNABLE_TO_GET_APPLICATION_FORM':
      return {
        code: 62,
        message: translateError(errorType),
      }
    case 'REQUESTED_LIMIT_TOO_LOW':
      return {
        code: 63,
        message: translateError(errorType),
      }
    case 'NOT_ENOUGH_LIMIT_ON_ACCOUNT':
      return {
        code: 64,
        message: translateError(errorType),
      }
    case 'INVALID_GOVERNMENT_ID_TYPE_ON_APPLICATION':
      return {
        code: 65,
        message: translateError(errorType),
      }
    case 'APPLICATION_FIELD_NOT_MATCHING_REGEXP':
      return {
        code: 66,
        message: translateError(errorType),
      }
    default:
      return {
        code: '',
        message: '',
      }
  }
}
